import { DocumentType } from 'api';
import { useFormContext } from 'form';

import type { UploadDocumentProps } from '../../types';
import { AddDocumentButton } from '../AddDocumentButton/AddDocumentButton';

type Documents = {
  documents?: UploadDocumentProps[];
};

type Props = {
  name: keyof Documents;
};

export const AddDocumentInMemoryButton = ({ name }: Props) => {
  const { setValue, getValues } = useFormContext<Documents>();
  const onAddDocumentInMemory = (file: File, documentType: DocumentType) => {
    const documents = getValues(name) || [];
    setValue(name, [...documents, { file: file, type: documentType }]);
  };

  return <AddDocumentButton onFileSelected={onAddDocumentInMemory} />;
};
